<template lang="pug">
v-dialog(v-model="show", max-width="520", scrollable)
  v-card.historico.Poppins
    .historico__header
      .historico__eyebrow
        v-icon(size="14", color="#3060CA") history
        span Histórico de alterações
      .historico__titulo(:title="titulo") {{ titulo }}
      .historico__subtitulo(v-if="subtitulo") {{ subtitulo }}

    v-card-text.historico__body
      .historico__estado(v-if="loading")
        v-progress-circular(:width="3", :size="32", color="primary", indeterminate)
        p Carregando histórico...

      .historico__estado.historico__estado--erro(v-else-if="erro")
        v-icon(size="32", color="#E0B4AE") error_outline
        p {{ erro }}
        v-btn(small, flat, color="primary", @click="carregar") Tentar novamente

      .historico__estado(v-else-if="!grupos.length")
        v-icon(size="32", color="#cfcfcf") history
        p Nenhuma alteração de status registrada até o momento.

      template(v-else)
        .historico__dia(v-for="grupo in grupos", :key="grupo.chave")
          .historico__dia-label {{ grupo.label }}
          ul.historico__timeline
            li.historico__evento(v-for="log in grupo.logs", :key="log.id")
              span.historico__marker(:class="'historico__marker--' + log.acao.classe")
                v-icon(size="14") {{ log.acao.icon }}
              .historico__card
                .historico__top
                  span.historico__acao(:class="'historico__acao--' + log.acao.classe") {{ log.acao.label }}
                  span.historico__hora {{ log.hora }}
                .historico__detalhes(v-if="log.detalhes.length")
                  span.historico__detalhe(v-for="detalhe in log.detalhes", :key="detalhe.campo")
                    span.historico__detalhe-campo {{ detalhe.campo }}:
                    span(v-if="detalhe.anterior") {{ detalhe.anterior }} →
                    strong {{ detalhe.atual }}
                .historico__autor
                  v-icon(size="15") {{ log.responsavel.icon }}
                  span.historico__autor-nome {{ log.responsavel.nome }}
                .historico__email(v-if="log.responsavel.email") {{ log.responsavel.email }}

    v-card-actions.historico__footer
      span.historico__total(v-if="!loading && !erro && total") {{ total }} {{ total === 1 ? 'registro' : 'registros' }}
      v-spacer
      v-btn(flat, @click="show = false") Fechar
</template>

<script>
import { agruparPorDia } from '@/util/logAtivacao';

export default {
  name: 'DialogHistoricoAlteracoes',
  data() {
    return {
      show: false,
      loading: false,
      erro: null,
      entidade: null,
      entidadeId: null,
      estabelecimentoId: null,
      titulo: '',
      subtitulo: '',
      grupos: [],
      total: 0,
      ticket: 0,
    };
  },
  methods: {
    abrir({ entidade, entidade_id, titulo, subtitulo, estabelecimento_id }) {
      const loja = this.$root.estabelecimentoSelecionado;
      this.entidade = entidade;
      this.entidadeId = entidade_id;
      this.estabelecimentoId = estabelecimento_id || (loja && loja.id) || null;
      this.titulo = titulo || '';
      this.subtitulo = subtitulo || '';
      this.show = true;
      this.carregar();
    },
    async carregar() {
      const vm = this;
      const ticket = ++vm.ticket;
      vm.loading = true;
      vm.erro = null;
      vm.grupos = [];
      vm.total = 0;
      try {
        const { data } = await vm.$axios.get('/log-ativacao', {
          params: {
            entidade: vm.entidade,
            entidade_id: vm.entidadeId,
            estabelecimento_id: vm.estabelecimentoId,
          },
        });
        if (ticket !== vm.ticket) {
          return;
        }
        const logs = data || [];
        vm.total = logs.length;
        vm.grupos = agruparPorDia(logs);
      } catch (error) {
        if (ticket !== vm.ticket) {
          return;
        }
        vm.erro = (error.response && error.response.data && error.response.data.error) || 'Não foi possível carregar o histórico.';
      } finally {
        if (ticket === vm.ticket) {
          vm.loading = false;
        }
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.historico {
  border-radius: 14px !important;
  overflow: hidden;

  &__header {
    padding: 20px 24px 14px;
    border-bottom: 1px solid #EFEFEF;
  }
  &__eyebrow {
    display: inline-flex;
    align-items: center;
    gap: 6px;
    background: #EEF3FC;
    color: #3060CA;
    border-radius: 20px;
    padding: 3px 11px;
    font-size: 11px;
    font-weight: 700;
    text-transform: uppercase;
    letter-spacing: 0.4px;
  }
  &__titulo {
    margin-top: 10px;
    font-size: 17px;
    font-weight: 600;
    color: #1a1a1a;
    line-height: 1.25;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
  &__subtitulo {
    margin-top: 2px;
    font-size: 12.5px;
    color: #888;
  }

  &__body {
    min-height: 140px;
    max-height: 60vh;
    padding: 16px 24px 12px !important;
    background: #F6F7F9;
  }
  &__estado {
    text-align: center;
    padding: 28px 0;
    color: #999;
    p {
      margin: 10px 0 0;
      font-size: 13.5px;
    }
    &--erro p { color: #7A1712; }
  }

  &__dia + &__dia { margin-top: 14px; }
  &__dia-label {
    font-size: 11px;
    font-weight: 700;
    color: #888;
    text-transform: uppercase;
    letter-spacing: 0.5px;
    margin-bottom: 8px;
  }

  &__timeline {
    list-style: none;
    margin: 0;
    padding: 0;
  }
  &__evento {
    position: relative;
    display: flex;
    align-items: flex-start;
    gap: 12px;
    padding-bottom: 10px;
    &:not(:last-child)::before {
      content: '';
      position: absolute;
      top: 34px;
      bottom: -6px;
      left: 13px;
      width: 2px;
      background: #E2E5EA;
    }
  }
  &__marker {
    position: relative;
    z-index: 1;
    margin-top: 6px;
    flex: 0 0 28px;
    width: 28px;
    height: 28px;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    background: #F0F0F0;
    .v-icon { color: inherit !important; }
    &--criacao     { background: #EEF3FC; color: #3060CA; }
    &--ativacao    { background: #E6F7EE; color: #1d7d4a; }
    &--desativacao { background: #FDECEC; color: #C0392B; }
    &--alteracao   { background: #FFF8EC; color: #8A6420; }
  }
  &__card {
    flex: 1 1 auto;
    min-width: 0;
    padding: 10px 14px 12px;
    background: #fff;
    border: 1px solid #E6E8EC;
    border-radius: 10px;
    box-shadow: 0 1px 2px rgba(0, 0, 0, 0.04);
  }
  &__top {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 8px;
  }
  &__hora {
    font-size: 12px;
    color: #999;
    font-variant-numeric: tabular-nums;
  }
  &__acao {
    display: inline-flex;
    align-items: center;
    padding: 2px 9px;
    border-radius: 6px;
    font-size: 10.5px;
    font-weight: 700;
    letter-spacing: 0.3px;
    text-transform: uppercase;
    line-height: 1.5;
    background: #F0F0F0;
    color: #757575;
    &--criacao     { background: #EEF3FC; color: #3060CA; }
    &--ativacao    { background: #E6F7EE; color: #1d7d4a; }
    &--desativacao { background: #FDECEC; color: #C0392B; }
    &--alteracao   { background: #FFF8EC; color: #8A6420; }
  }
  &__detalhes {
    display: flex;
    flex-wrap: wrap;
    gap: 4px 14px;
    margin-top: 6px;
    font-size: 12.5px;
    color: #5b5b5b;
  }
  &__detalhe {
    display: inline-flex;
    gap: 4px;
    strong {
      color: #1a1a1a;
      font-weight: 600;
    }
  }
  &__detalhe-campo { color: #888; }
  &__autor {
    display: flex;
    align-items: center;
    gap: 6px;
    margin-top: 6px;
    font-size: 13px;
    color: #3a3a3a;
    .v-icon { color: #bbb !important; }
  }
  &__autor-nome { font-weight: 600; }
  &__email {
    margin-top: 1px;
    padding-left: 21px;
    font-size: 12px;
    color: #888;
    word-break: break-all;
  }

  &__footer {
    padding: 10px 16px 10px 24px;
    border-top: 1px solid #EFEFEF;
  }
  &__total {
    font-size: 12px;
    color: #999;
  }
}
</style>
